<template>
    <div>
        <div class="breadcrumbs">
            <div class="col-sm-4">
                <div class="page-header float-left">
                    <div class="page-title">
                        <h1>오더 수정 내역</h1>
                    </div>
                </div>
            </div>
        </div>

        <b-container fluid class="animated fadeIn">
            <div class="card">
                <div class="card-header">
                    <strong class="card-title">오더 수정 내역 조회</strong>
                </div>
                <div class="card-body" >
                    <div class="w-25 mb-3 mr-2">

                    </div>

                    <div class="mb-3 float-left">
                        <b-row align-h="middle" align-v="center">

                            <b-col cols="auto" ><strong class="align-middle">검색된 목록 수 : {{totalRows}}</strong></b-col>
                        </b-row>
                    </div>
                    <div class="ml-3 float-right">
                        <b-button class="mb-2" size="md" variant="primary" @click="refreshTable">검색</b-button>
                    </div>
                    <div class="mb-3 float-right">
                        <b-row align-h="end" align-v="center">
                            <b-col  md="auto">
                                <b-form-group
                                    label="선택 :"
                                    label-for="empState"
                                    :label-cols="4"
                                    :horizontal="true">
                                    <b-input-group>
                                        <b-form-select v-model="state">
                                            <option value="0">전체</option>
                                            <option value="30001">미완료</option>
                                            <option value="30002">완료</option>
                                        </b-form-select>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col cols="auto" ><strong class="align-middle">수정일</strong></b-col>
                            <b-col>
                                <datepicker
                                    placeholder="날짜"
                                    :bootstrapStyling="true"
                                    :clearButton="true"
                                    clear-button-icon="fa fa-times"
                                    :calendarButton="true"
                                    calendar-button-icon="fa fa-calendar"
                                    format="yyyy-MM-dd"
                                    :value="fromDate"
                                    v-model="fromDate"
                                    :language="lang"
                                    />
                            </b-col>~
                            <b-col>
                                <datepicker
                                    placeholder="날짜"
                                    :bootstrapStyling="true"
                                    :clearButton="true"
                                    clear-button-icon="fa fa-times"
                                    :calendarButton="true"
                                    calendar-button-icon="fa fa-calendar"
                                    format="yyyy-MM-dd"
                                    :value="toDate"
                                    v-model="toDate"
                                    :language="lang"
                                    />
                            </b-col>
                        </b-row>

                    </div>

                    <b-table style="width: 100%; max-height: 70vh;"
                        :responsive="true"
                        flex
                        :fixed="true"
                        show-empty
                        empty-text="조회된 내용이 없습니다."
                        empty-filtered-text="조회된 내용이 없습니다."
                        ref="historyTable"
                        :small="true"
                        :striped="false"
                        :bordered="true"
                        hover
                        :items="useageHistory"
                        :fields="colums"
                        :per-page="perPage"
                        :current-page="currentPage">
                        <template slot="btn_complete" slot-scope="row" v-if="row.item.state == 30001">
                            <b-button  size="sm" @click.stop="modifyComplete(row.item)" class="mr-1">
                            수정완료
                            </b-button>
                        </template>
                        <template slot="managerName" slot-scope="row">
                            <b-form-input id="addr" class="mb-2" type="text" placeholder="처리자" v-model="row.item.managerName" :readonly="row.item.state == 30002" >
                            </b-form-input>
                        </template>
                    </b-table>

                    <b-pagination size="md" align="center" :total-rows="totalRows" :limit="10" :hide-ellipsis="true" :per-page="perPage" v-model="currentPage" />

                </div>
            </div>
        </b-container>

    </div>
</template>
<script>
import {modifiedHistory} from '../data/table.js'
import Datepicker from 'vuejs-datepicker'
import kakaoApi from '../api/kakao'
import employeeApi from '../api/employee'
import ResultMessage from '../data/resultMessage'
import {ko} from 'vuejs-datepicker/dist/locale'
import {mapGetters} from 'vuex'

export default {
    name: 'SearchOrders',
    components: {
        Datepicker
    },
    data() {
        return {
            colums: modifiedHistory.fields,
            // items: [],
            checkedValues : [],
            currentPage: 1,
            perPage: 10,
            totalRows: 1,
            filteredItems: [],
            fromDate: this.calcDate(-7),
            toDate: this.calcDate(0),
            lang: ko,
            state: 0,
            mngrName: null
        }
    },
    computed: {
        ...mapGetters({
            userAccount: 'userAccount/userAccount'
        })
    },
    methods : {
        selectedCheckBox : function(orderNo) {
            alert(orderNo);
        },
        useageHistory: function(ctx) {
            let resultMessage = new ResultMessage();
            let items = null;
            let queryString = {};
            queryString.fromDate = this.fromDate.toISOString().split("T")[0];
            queryString.toDate = this.toDate.toISOString().split("T")[0];
            queryString.currentPage = ctx.currentPage;
            queryString.state = this.state;
            queryString.callVendor = this.userAccount.callVendorNo;
            return employeeApi.modifiedHistory(queryString).then(response => {
                resultMessage.buildSuccessMessage(response);
                if(resultMessage.payload != null) {
                    items = resultMessage.payload.contents;
                    this.perPage = resultMessage.payload.perContentCnt;
                    this.currentPage = resultMessage.payload.currentPage;
                    this.totalRows = resultMessage.payload.totalContentCnt;
                }
                this.filteredItems = items;
                return (items || []);
            }).catch(error => {
                resultMessage.buildErrorMessage(error);
                alert(resultMessage.message);
                return []
            });
        },
        refreshTable: function() {
            this.$refs.historyTable.refresh();
        },
        calcDate : function (daysToAdd) {
            let date = new Date();
            date.setDate(date.getDate() + daysToAdd);
            return date;//date.toISOString().split("T")[0];
        },
        modifyComplete : function(item) {
            if(item.managerName == '' || item.managerName == null) {
                alert('처리자 이름을 입력 해 주세요');
                return;
            }
            let resultMessage = new ResultMessage();
            let queryString = {};
            queryString.pid = item.pid;
            queryString.managerName = item.managerName;
            employeeApi.updateModifiedState(queryString).then(response => {
                alert('수정 되었습니다.');
            }).catch(error => {
                resultMessage.buildErrorMessage(error);
                alert(resultMessage.message);
            });
            this.refreshTable();
        }
    },
    mounted: function() {
        // 최초 로딩 데이터 조회
        //this.useageHistory();
    }
}
</script>
<style lang="scss" scoped>
@import '../assets/css/lib/datatable/dataTables.bootstrap.min.css';

.scroll-table {
  width: 100%;

  overflow-x: auto;
}

</style>



// WEBPACK FOOTER //
// src/components/OrderMonitoring.vue